// The couple details a supplier needs on an enquiry, in the order they are asked for.
export const ENQUIRY_DETAILS = ['partnerNames', 'email', 'phone'] as const;

export type EnquiryDetail = (typeof ENQUIRY_DETAILS)[number];
